import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'

const MethodSelect = () => {

	const App = useApp()
	const [termsLayer, setTermsLayer] = useState(false)

	const closeTerms = () => {
		setTermsLayer(false)
	}

	const showTerms = () => {
		setTermsLayer(true)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div className={styles["count-group"]}>
					<p>인증 수단 선택</p>
					<div><span>2</span>/3</div>
				</div>
				<ul className={`${styles.certification} mt_40`}>
					<li>
						<p>통합인증</p>
						<div className={styles.box}>
							<div className="flex-align_center">
								<span className={styles.circle}>
									<i className="icon icon_document_lock" />
								</span>
								<p>공동인증서</p>
							</div>
							<div className="chk">
								<input type="radio" id="radio1" name="method" />
								<label htmlFor="radio1">
									<span></span>
								</label>
							</div>
						</div>
						<div className={styles.box}>
							<div className="flex-align_center">
								<span className={styles.circle}>
									<i className="icon icon_naver" />
								</span>
								<p>네이버인증서</p>
							</div>
							<div className="chk">
								<input type="radio" id="radio2" name="method" />
								<label htmlFor="radio2">
									<span></span>
								</label>
							</div>
						</div>
					</li>
					<li>
						<p>통합인증</p>
						<div className={styles.box}>
							<div className="flex-align_center">
								<span className={styles.circle}>
									<i className="icon icon_star_badge" />
								</span>
								<p>공동인증서</p>
							</div>
							<div className="chk">
								<input type="radio" id="radio3" name="method" />
								<label htmlFor="radio3">
									<span></span>
								</label>
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={showTerms}>다음</Button>
			</div>

			<TermsLayer show={termsLayer} closeTerms={closeTerms} />
		</div>
	)
}

const TermsLayer = ({ show, closeTerms }) => {
	return (
		<LayerBottom title={
			<div>공동인증서 인증을 위해<br />동의가 필요해요.</div>
		} show={show} closeTerms={closeTerms} outside={
			<Button className="btn btn--big btn-layer" onClick={closeTerms} disabled>모두 동의하고 진행하기</Button>
		}>
			<ul className="terms-list">
				<li>
					<div className="flex-justify_between align_center">
						<div className="chk">
							<input type="checkbox" id="check1" name="state" />
							<label htmlFor="check1">
								<span>인증서 본인확인 서비스 이용약관</span>
							</label>
						</div>
						<i className="icon icon_arrow_sm right" />
					</div>
				</li>
				<li>
					<div className="flex-justify_between align_center">
						<div className="chk">
							<input type="checkbox" id="check2" name="state" />
							<label htmlFor="check2">
								<span>개인(신용)정보 처리 동의</span>
							</label>
						</div>
						<i className="icon icon_arrow_sm right" />
					</div>
				</li>
				<li>
					<div className="flex-justify_between align_center">
						<div className="chk">
							<input type="checkbox" id="check3" name="state" />
							<label htmlFor="check3">
								<span>고유식별번호 수집 ・ 이용 및 위탁 동의</span>
							</label>
						</div>
						<i className="icon icon_arrow_sm right" />
					</div>
				</li>
			</ul>
		</LayerBottom>
	)
}

export default MethodSelect